{
  "translations": {
    "Change Customer Email": "Change Email Addresses",
    "Customer Service": "Customer Service",
    "content": {
      "addressForm": {
        "addName": "New",
        "addNameDescription": "A private forwarding order can cover up to {{num}} names at the same address for free.",
        "city": "City",
        "cityPlaceholder": "City",
        "country": "Country",
        "countryPlaceholder": "Country",
        "name": "Name",
        "nameForReturns": "Name",
        "nameForSources": "Name",
        "namePlaceholder": "Name",
        "namePlaceholderForReturns": "Complete Name",
        "namePlaceholderForSources": "Complete Name",
        "street": "Street and House Number",
        "streetPlaceholder": "Street and House Number",
        "subject": "Subject",
        "subjectPlaceholder": "Subject",
        "submitFailed": "Saving was not successful",
        "validation": {
          "maxCharsN": "Maximum {{num}} characters",
          "maxNamesN": "Maximum {{num}} names",
          "nChars": "Must be {{num}} characters long",
          "required": "This is a mandatory field"
        },
        "zip": "Postcode",
        "zipPlaceholder": "Postcode"
      },
      "sourceForm": {
        "addFreeSource": "Book now — it's free",
        "addSource": "Book now for {{value}} €",
        "business": "Business",
        "city": "City",
        "cityPlaceholder": "City",
        "country": "Country",
        "countryPlaceholder": "Country",
        "name": "Name",
        "namePlaceholder": "Name",
        "private": "Private",
        "street": "Street and House Number",
        "streetPlaceholder": "Street and House Number",
        "submitFailed": "Saving was not successful",
        "validation": {
          "nChars": "{{num}} characters expected",
          "required": "This is a mandatory field"
        },
        "zip": "Postcode",
        "zipPlaceholder": "Postcode"
      }
    },
    "customerDetails": {
      "captureChecks": {
        "customerNames": "Customer names",
        "publicId": "Public ID"
      },
      "confirm": {
        "close": {
          "body": "These sections have unsaved changes that will be lost: {{sections}}",
          "okText": "Discard and close",
          "title": "Close without saving?"
        },
        "closeWhileSaving": {
          "body": "Still saving: {{sections}}. Closing does not cancel writes already sent to the server, so those changes may still be applied.",
          "cancelText": "Wait",
          "okText": "Close anyway",
          "title": "Saving is still in progress"
        },
        "combinedTitle": "Save these changes?",
        "scanCenter": "Change the scan centre from {{from}} to {{to}}?",
        "scheduleOff": "Turn the return schedule off?",
        "scheduleOn": "Set the returns interval to {{interval}}?"
      },
      "fields": {
        "account": "Account",
        "automaticTransfer": "Automatic transfer",
        "containerIdPlaceholder": "Container ID",
        "disabledChecks": "Disabled checks",
        "document": "Document",
        "metabaseDashboardId": "Metabase Dashboard ID",
        "paywalledSince": "since {{since}}",
        "retiredScanCenter": "{{scanCenter}} (no longer operating)",
        "returnsInterval": "Returns interval",
        "returnsNextAt": "Next return date"
      },
      "notifications": {
        "captureSettingsSaved": "Capture settings saved",
        "reportingSaved": "Metabase Dashboard ID saved",
        "returnsSaved": "Originals & returns saved",
        "saveFailed": "Save failed",
        "scheduleNotSaved": "Scan centre saved, return schedule did not: {{reason}}"
      },
      "returnIntervals": {
        "BI_WEEKLY": "Bi-weekly",
        "DAILY": "Daily",
        "HALF_YEARLY": "Half-yearly",
        "MONTHLY": "Monthly",
        "OFF": "Off",
        "QUARTERLY": "Quarterly",
        "WEEKLY": "Weekly",
        "YEARLY": "Yearly"
      },
      "sections": {
        "account": "Account",
        "actions": "Actions",
        "captureSettings": "Capture settings",
        "identity": "Identity",
        "originalsAndReturns": "Originals & returns",
        "reporting": "Reporting"
      },
      "status": {
        "saved": "Saved",
        "unsaved": "Unsaved changes"
      }
    },
    "customerDocumentActions": {
      "addToReturnBasket": "Add to returnbasket",
      "errorMessages": {
        "EMPTY_OPEN_RETURN": "This customer has no documents in their return basket, so there is nothing to order.",
        "EMPTY_RETURN_ADDRESS": "This customer has no return address, so the return cannot be shipped.",
        "generic": "The return could not be ordered, please try again.",
        "RETURN_REQUEST_IN_PROGRESS": "This customer already has a return being prepared, ordering another one is blocked until it finishes.",
        "RETURN_REQUEST_IN_PROGRESS_startedAt": "This customer already has a return being prepared since {{startedAt}}, ordering another one is blocked until it finishes."
      },
      "noAvailableActions": "No actions available",
      "successMessages": {
        "addToReturnBasket": "Document added to return basket",
        "returnSentSuccessfully": "All returns successfully requested",
        "unDelete": "Document restored",
        "unShred": "Document un-shredded"
      },
      "unDelete": "Un-Delete",
      "unShred": "Un-Shred",
      "waitingForInput": "Enter valid Document ID"
    },
    "Delete a document": "Delete documents",
    "Disable Customer": "Disable Customers",
    "deleteDocuments": {
      "documentDeletedSuccessfully": "Document ${documentId} deleted successfully",
      "documentDetailPreview": "Document preview",
      "documentReassignedSuccessfully": "Document {{documentId}} reassigned successfully",
      "errorDeletingDocument": "Error deleting document",
      "errorMessageFatal": "Something went totally wrong!",
      "errorReassigingDocument": "Error reassigning the document",
      "noDocumentsSelected": "No documents selected",
      "removeDocument": "Delete Document",
      "searchDocumentInputLabel": "Enter document ID",
      "searchDocumentInputPlaceholder": "Document ID"
    },
    "disableCustomer": {
      "disableAccount": "Deactivate User Account",
      "errorText": "Oops! An error has occurred: ",
      "modalBody": "Do you wish to disable this customer account?",
      "modalTitle": "Are you sure you want to disable this customer?",
      "successText": "Customer access has been successfully disabled"
    },
    "disableCustomerSearchPlaceholder": "Enter a Public ID, an email address, a first or last name to find a customer",
    "documentView": {
      "AutomaticProcess": "AutomaticProcess",
      "addTag": "Add Tag +",
      "amount": "Amount",
      "amountInvalid": "Amount invalid, maybe not a number",
      "amountValid": "Amount valid",
      "CustomerAndPublicNotFound": "Neither Public ID nor customer name found",
      "CustomerNamesNone": "No customer name extracted",
      "CustomerNamesNotFound": "Customer name not found",
      "city": "City",
      "clearPayment": "Delete payment data",
      "customerInfoError": "Error loading customer data",
      "DatabreachWarning": "!!!Possible DATABREACH!!!",
      "email": "Email",
      "fillSender": "Sender is Recipient",
      "ibanInvalid": "IBAN invalid",
      "ibanValid": "IBAN valid",
      "natifMetadata": {
        "date": {
          "placeholder": "DD.MONTH.YYYY",
          "title": "Datestamp"
        },
        "scanId": {
          "placeholder": "123.123.123",
          "title": "Scan barcode"
        },
        "title": "Natif extraction"
      },
      "PublicIdFuzzy": "PublicIdFuzzy",
      "PublicIdMoreThanOne": "More than one Public ID found",
      "PublicIdNone": "No Public ID found",
      "PublicIdsDontMatch": "Public ID in document doesn't match Public ID in file name",
      "payment": "Payment Data",
      "paymentForm": {
        "amount": {
          "label": "Amount (EUR,Ct.)",
          "placeholder": "Amount (EUR,Ct.)"
        },
        "iban": {
          "label": "IBAN",
          "placeholder": "IBAN"
        },
        "recipient": {
          "label": "Payment Recipient",
          "placeholder": "Payment Recipient"
        },
        "reference": {
          "label": "Payment Reference (min. 5 / max. 140 characters)",
          "placeholder": "Payment Reference (min. 5 / max. 140 characters)"
        },
        "validation": {
          "fieldRequired": "This is a mandatory field",
          "invalid": {
            "bic": "BIC is invalid",
            "iban": "IBAN is invalid"
          },
          "invalidCharsForField": "There are invalid characters, please only use A-z, 0-9, +-,.?/",
          "invalidIban": "IBAN is invalid",
          "maxCharsN": "Maximum number of characters allowed is {{limit}}",
          "maxDecimalsN": "Not more than {{precision}} decimals",
          "minCharsN": "Should be longer than {{limit}} characters",
          "minNumN": "Should be longer than {{limit}} characters",
          "reservedWord": "This word can not be used",
          "typeNaN": "Please supply a number"
        }
      },
      "phone": "Phonenumber",
      "pleaseCheck": "⚠️ Please check!",
      "postCode": "Postcode",
      "previewLimit": "Preview limited to 10 of",
      "publicId": "Public ID",
      "receiver": "Recipient",
      "reference": "Payment Reference",
      "scanMetadata": {
        "scanDate": {
          "placeholder": "DD.MONTH.YYYY",
          "title": "Timestamp"
        },
        "scanId": {
          "placeholder": "123.123.123",
          "title": "Scan barcode"
        },
        "title": "Naming convention"
      },
      "sender": "Sender",
      "streetAndNumber": "Street and House Number",
      "to": {
        "placeholder": "Receiver’s name",
        "title": "To"
      },
      "transfer": "Transfer",
      "transferAllDialog": {
        "deletePerm": "Execute irrevocably",
        "filteredListMessage": "All documents from this view will be transferred. Afterwards changes are not possible anymore.",
        "transferAllDocuments": "Transfer all documents"
      },
      "unknown": "Unknown",
      "userId": "User ID"
    },
    "emailChangeForm": {
      "updateMailFormButtonLabel": "Update Email Address",
      "updateMailFormInputPlaceholder": "New e-mail address"
    },
    "Finished": "Finished",
    "faultyDocuments": {
      "notifications": {
        "error": "Error",
        "filenameChangedDescription": "Well done! 🎉",
        "filenameChangedTitle": "Filename successfully changed",
        "filenameNotChangedDesc": "Please change the filename",
        "filenameNotChangedTitle": "Filename was not changed"
      },
      "refetch": "Reload",
      "table": {
        "actions": "Actions",
        "cancelRename": "Cancel renaming",
        "filename": "Filename",
        "openInNewTab": "Open <0>{{filename}}</0> in new tab",
        "rename": "Rename",
        "type": "Error Type"
      }
    },
    "home": {
      "assignTagger": {
        "actionButton": "Fetch {{num}} documents",
        "error": "Something went wrong, please try again",
        "noAvailableDocuments": "No documents available for tagging",
        "success": "Documents assigned to you"
      },
      "documentsFilter": "Documents Filter",
      "failedToFetchDocuments": "Failed to fetch documents",
      "somethingWentWrong": "Something went wrong:"
    },
    "Inbox": "Inbox",
    "Login": "Login",
    "labels": {
      "all": "All",
      "cancel": "Cancel",
      "clone": "Clone",
      "darkMode": "Dark mode",
      "delete": "Delete",
      "discard": "Discard",
      "filteredCount": "Total documents: {{num}}",
      "filteredOf": "of",
      "filteredText": "",
      "lightMode": "Light mode",
      "login": "Login",
      "logout": "Logout",
      "no": "No",
      "noExtension": "No extension",
      "ok": "OK",
      "predictedRecepients": "Predicted recepients: ",
      "reset": "Reset",
      "save": "Save",
      "search": "Search",
      "searchFor": "Search for {{item}}",
      "taggers": "Taggers",
      "unfiltered": "Unfiltered",
      "yes": "Yes"
    },
    "Mail Forwarding Order": "Forwardings",
    "misc": {
      "action": "Action",
      "address": "Address",
      "companyName": "Company Name",
      "confirmationDialog": {
        "cancelText": "No",
        "okText": "Yes",
        "title": "Are you sure?"
      },
      "contactName": "Contact name",
      "country": "Country",
      "customerDetails": "Customer details",
      "delete": "Delete",
      "disabled": "Disabled",
      "done": "Done",
      "email": "Email",
      "error": "Error",
      "firstName": "First Name",
      "lastName": "Last Name",
      "month": "Month",
      "months": "Months",
      "noAddress": "Customer has not entered an address",
      "noDateSet": "No date. Click to set.",
      "noExternalId": "<No External ID>",
      "orderReturns": "Order returns",
      "pages": "pages",
      "requestedAt": "Requested at",
      "returnBasket": "In Returnbasket",
      "scanCenter": "Scan Center",
      "send": "Send",
      "success": "Success!",
      "user": "User"
    },
    "natifErrorReport": {
      "confirmMessage": "Are you sure you want to send an extraction error report?",
      "document": {
        "buttonTitle": "Send Document Error Report"
      },
      "errorMessage": "Failed Error Report: {{error}}",
      "successMessage": "Error Report send successfully!",
      "tags": {
        "buttonTitle": "Send Tag Error Report"
      }
    },
    "navigationDrawer": {
      "changeCustomerEmail": "Change Email Addresses",
      "customerDetails": "Customer Details",
      "deleteDocuments": "Delete Documents",
      "filesWithErrors": "Files with Errors"
    },
    "Password": "Password",
    "paywallCustomer": {
      "disableAccount": "Paywall User Account",
      "errorText": "Oops! An error has occurred: ",
      "modalBody": "Do you wish to paywall this customer account?",
      "modalTitle": "Are you sure you want to paywall this customer?",
      "successText": "Customer access has been successfully paywalled",
      "successTitle": "Paywall On",
      "switch": {
        "disabled": "off",
        "enabled": "on",
        "label": "Paywalled"
      },
      "uploadCSV": {
        "button": "Upload paywall CSV",
        "error": {
          "fileFormat": "there were issues with CSV format, check dev console for more information",
          "update": "Some updates failed"
        },
        "success": "All paywall updates were successful"
      }
    },
    "Return": "Returns",
    "returns": {
      "actions": "Actions",
      "count": "# of docs",
      "date": "Date",
      "dhlTrackingUploadCompletedMsg": "DHL Tracking Codes uploaded successfully!",
      "emptyCsv": {
        "message": "None of the loaded returns holds a document with a scan id in this scan center.",
        "title": "Nothing to export"
      },
      "finishedBy": "Return Type",
      "importingCompleted": "Import completed",
      "loadMore": "Load more",
      "noDocuments": "No documents in this return",
      "noReturns": "No returns",
      "receiver": "Receiver",
      "returnsCsv": {
        "Ods": "Returns for ODS",
        "Sps": "Returns for SPS",
        "Srz": "Returns for SRZ"
      },
      "sender": "Sender",
      "somethingWentWrongMsg": "Something went wrong, please try importing the file again.",
      "subject": "Subject",
      "uploadTrackingCsvBtnLabel": "Upload DHL Tracking CSV"
    },
    "Stay Logged In": "Stay logged in",
    "searchCustomerInputPlaceholder": "Enter a Public ID, an email address, a first or last name to find a customer.",
    "sources": {
      "CSVUploadCompleteBody": "The forwardings were updated",
      "CSVUploadCompleteTitle": "Import completed",
      "confirmationModal": {
        "body": "This Forwarding is not supposed to be extended. Continue cloning?",
        "title": "Please note"
      },
      "duration": "Duration",
      "endAt": "End Date",
      "invalidCSVFile": "Errors in CSV file: check invalid rows in downloaded file",
      "somethingWentWrong": "Something went wrong",
      "sourceActions": {
        "activate": "Activate",
        "activating": "Activating",
        "cancel": "Cancel",
        "noExtension": "Don't extend",
        "request": "Initiated processing"
      },
      "sourceStages": {
        "Activated": "Active",
        "Activating": "Processing",
        "Canceled": "Canceled",
        "Cancelling": "Cancelling",
        "Expired": "Expired",
        "Expiring": "Expiring",
        "NoExtension": "Not extended",
        "Renewing": "Renewing",
        "Requested": "Ordered by customer"
      },
      "startAt": "Start Date",
      "type": "Type",
      "uploadCSVButton": "upload CSV",
      "uploadCSVCancellationButton": "upload cancellation CSV"
    },
    "titles": {
      "appTitle": "Inbox",
      "customerDetails": "Customer Details",
      "forwardsTitle": "Forwardings",
      "returnsTitle": "Returns"
    },
    "Username": "Username",
    "unPaywallCustomer": {
      "disableAccount": "Remove Paywall For User Account",
      "errorText": "Oops! An error has occurred: ",
      "modalBody": "Do you wish to remove paywall for this customer account?",
      "modalTitle": "Are you sure you want to remove paywall for this customer?",
      "successText": "Customer access has been successfully enabled",
      "successTitle": "Paywall Off"
    }
  }
}
